import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  desc?: string;
  actionLabel?: string;
  onAction?: () => void;
  linkTo?: string;
}

export default function EmptyState({ icon = 'ri-inbox-line', title, desc, actionLabel, onAction, linkTo }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <h3 className="mt-5 text-lg font-semibold text-foreground-800">{title}</h3>
      {desc && <p className="mt-2 max-w-md text-sm text-foreground-500">{desc}</p>}
      {actionLabel && (
        <div className="mt-6">
          {linkTo ? (
            <Link
              to={linkTo}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              {actionLabel}
            </Link>
          ) : (
            <button
              type="button"
              onClick={onAction}
              className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
            >
              {actionLabel}
            </button>
          )}
        </div>
      )}
    </div>
  );
}